import { useQuery } from '@hooks/reactQuery';

import { getOrganisationProjectWorkflows } from '@api/projectManagement';

import { workflowsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_WORKFLOWS } from '@constants/queryKeys';

interface IUseQueryProjectWorkflowsReturned {
	projectsWorkflows: Array<TSelectOption>;
	isLoadingProjectsWorkflows: boolean;
}

export const useQueryOrganisationProjectWorkflows = (): IUseQueryProjectWorkflowsReturned => {
	const {
		data: projectsWorkflows,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_WORKFLOWS],
		allowedRoles: [
			EUserRoles.assetOwnerOrganizationAdministrator,
			EUserRoles.networkOperatorOrganizationAdministrator,
			EUserRoles.assetConsumerOrganizationAdministrator,
		],
		queryFn: getOrganisationProjectWorkflows,
		select: requestTypes => workflowsOptionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectsWorkflows: projectsWorkflows || [],
		isLoadingProjectsWorkflows: isInitialLoading || isFetching,
	};
};
